export const otto = {
  tokenHelp:
    'The token can be found under "Settings > Store-level API account"',
  oAuthFlowHelp: "Authorise my account",
  useSandbox: "Activate {appName} sandbox",
  authSuccess: "Authentication successful",
  installationTitle: "Installation of the Connect Otto Market App",
  installAction: "Install app",
  errorHandling: {
    ottoInstallationNotFoundTitle:
      "We couldn’t find an Otto installation for this version.",
    ottoInstallationNotFound:
      "<p>No worries, this usually means the Otto app isn’t installed yet.</p>" +
      "<p>Install the Otto app in your Otto portal using the link below:</p>" +
      "<a class='btn btn-primary' href='{link}'><strong>Install Otto app</strong></a><br>" +
      "<p></p>" +
      "<p></p>" +
      "<p></p>" +
      "<p>After the installation is complete, restart the setup and try again.</p>"
  }
};
